import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filename',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class FilenamePipe implements PipeTransform {
  transform(filename = '', formatting = false): string {
    if (formatting) {
      const invalidCharsRegex = /[^a-zA-Z0-9_.-]/g;
      filename = filename.replace(invalidCharsRegex, '_');
    }

    const lastDotIndex = filename.lastIndexOf('.');

    if (lastDotIndex !== -1 && lastDotIndex !== 0) {
      return filename.substring(0, lastDotIndex);
    } else {
      return filename;
    }
  }
}
